import { mpReconciliationStatus } from '@/context/services/invoice/type';
import { UnsetOption } from '@/features/invoices/components/List/Search/ReconciliationStatus/UnsetOption';
import { useTranslation } from '@/i18n';
import { SelectProps } from '@moneyforward/ap-frontend-components';
import { useMemo } from 'react';

export const useReceivedInvoiceReconciliationStatusOptions =
  (): SelectProps['options'] => {
    const { t } = useTranslation();

    return useMemo(
      () =>
        [
          {
            value: mpReconciliationStatus.unset,
            label: t('received_invoice_reconciliation_status_unset'),
            render: <UnsetOption />,
          },
          {
            value: mpReconciliationStatus.excluded,
            label: t('received_invoice_reconciliation_status_excluded'),
          },
          {
            value: mpReconciliationStatus.waiting,
            label: t('received_invoice_reconciliation_status_waiting'),
          },
          {
            value: mpReconciliationStatus.sent,
            label: t('received_invoice_reconciliation_status_sent'),
          },
        ].map((option) => ({
          ...option,
          tooltip: '',
        })),
      [t]
    );
  };
